import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=dd654e3e&"
import script from "../../models/communication/index.ts?vue&type=script&lang=ts&"
export * from "../../models/communication/index.ts?vue&type=script&lang=ts&"
import style0 from "./Index.vue?vue&type=style&index=0&id=dd654e3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports